"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_icon_1 = require("@travelnest/merlin.icon");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const CHIP_BORDER = '21px';
const ChipWrapper = styled_1.default.div `
	display: inline-block;
	margin: 10px 20px 0 0;
	color: ${merlin_theme_1.default.colours.neutral.darkest};
	position: relative;

	&:focus {
		outline: none;
		.chip_not-selected {
			border: 1px solid #343434;
		}
	}

	&:focus:after {
		content: '';
		position: absolute;
		top: -2px;
		left: -2px;
		width: calc(100% + 4px);
		height: calc(100% + 4px);
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		box-sizing: border-box;
		border-radius: calc(${CHIP_BORDER} + 2px);
		cursor: pointer;
	}

	.chip_content {
		display: inline-block;
		line-height: 40px;

		/* Icon div */
		& > div {
			display: inline-block;
			vertical-align: middle;
			height: 25px;
			width: 25px;
			padding: 0;
		}
	}

	.chip {
		height: 40px;
		display: inline-block;
		border-radius: ${CHIP_BORDER};
		padding-left: 15px;
		padding-right: 20px;
		cursor: pointer;
		transition: border 0.2s, background-color 0.2s;
	}

	.chip_text {
		display: inline-block;
		padding-left: 5px;
		padding-top: 2px;
		vertical-align: middle;
	}

	.chip_is-selected {
		background-color: ${merlin_theme_1.default.colours.primary.primary};
		border: 1px solid ${merlin_theme_1.default.colours.primary.primary};
		color: white;
	}

	.chip_not-selected {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	}

	.chip_not-selected:hover {
		/* TODO: This colour should be in theme? */
		border: 1px solid #343434;
	}
`;
const getIconColour = (selected, hover) => {
    if (selected)
        return 'white';
    else if (hover)
        return 'darkGrey';
    else
        return 'lightGrey';
};
const Chip = (props) => {
    const { id, text, selected, onChange } = props;
    const [hover, setHover] = React.useState(false);
    const tapHandler = () => {
        const toggle = !selected;
        if (onChange !== undefined) {
            onChange(id, toggle);
        }
    };
    const icon = selected ? 'check' : 'plus';
    const chipClasses = ['chip', selected ? 'chip_is-selected' : 'chip_not-selected'].join(' ');
    const iconColour = getIconColour(selected, hover);
    return (React.createElement(ChipWrapper, { tabIndex: 0, role: "button", id: id, onClick: tapHandler, onKeyPress: (event) => {
            // if key pressed is enter or spacebar
            if (event.key === 'Enter' || event.key === ' ') {
                tapHandler();
            }
        }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), onFocus: () => setHover(true), onBlur: () => setHover(false) },
        React.createElement("span", { className: chipClasses },
            React.createElement("span", { className: "chip_content" },
                React.createElement(merlin_icon_1.Icon, { icon: icon, colour: iconColour }),
                React.createElement("span", { className: "chip_text" }, text)))));
};
exports.Chip = Chip;
//# sourceMappingURL=Chip.js.map